export default "/images/BronzeAward.png?903cc1a10896da12dee8de85214a1e05";